import { CardInfo } from "./card-info.model";

export class CardSuggestion{
    /*
    *
    */
    constructor(
      public id?:  number,
      public displaySorting?: number,
      public photo?: string,
      public cardInfo?: CardInfo
    ){}
}